<h2 data-testid="SUBSYS5_TREATPROGRESSBAR_TITLE" class="text-uppercase">
	{{ labels().TREATMENT_PROGRESSBAR_COMPONENT_TITLE }}
</h2>

<div class="form-group mt-5">
	<label data-testid="SUBSYS5_TREATPROGRESSBAR_CONSOLIDATIONDAYS_LBL" for="consolidation-days"
		class="d-inline-block mb-0">
		{{ labels().TREATMENT_PROGRESSBAR_COMPONENT_CONSOLIDATION_DAYS }} &nbsp; *
	</label>
	<div class="spinner d-inline-flex ms-5">
		<span class="material-icons md-18" [class.disabled]="isReadonly()" (click)="sub()" (keypress)="sub()">remove</span>
		<input data-testid="SUBSYS5_TREATPROGRESSBAR_CONSOLIDATIONDAYS_INPUT" id="consolidation-days" type="number"
			class="custom-control" style="min-width: 5rem;" [ngModel]="consolidation().days" (ngModelChange)="update($event)"
			(keypress)="checkKey($event)" (paste)="checkPaste($event)" [readOnly]="isReadonly()" />
		<span class="material-icons md-18" [class.disabled]="isReadonly()" (click)="add()" (keypress)="add()">add</span>
	</div>
	@if (!isConsolidationValid()) {
	<div data-testid="SUBSYS5_TREATPROGRESSBAR_CONSOLIDATIONDAYS_ERROR_TXT" class=" text-danger d-inline-block ms-5"
		style="width: fit-content;">
		{{ labels().VALIDATION_RANGE | replace:DAYS_MIN:DAYS_MAX }}
	</div>
	}
</div>


<div class="treatment-progress-bar">
	<div class="panel mb-0">
		<div class="treatment-frame-box">
			<div>{{ labels().TREATMENT_PROGRESSBAR_COMPONENT_FRAME_ID }}</div>
			<div data-testid="SUBSYS5_TREATPROGRESSBAR_FRAMEID_TXT" class="frame-value">{{ frameId() }}</div>
		</div>
	</div>
	<div>
		<ngb-progressbar-stacked class="progress-bar-invisible treatment-icon-bar">
			@if (latency().days) {
			<ngb-progressbar [value]="latency().size" [max]="TOTAL_SIZE">
				<div class="text-center">
					<div><img id="latency_icon" src="images/ico_latency_white.png" alt="latency_icon"></div>
					<div><label for="latency_icon" class="overflow-hidden px-3">
							{{ labels().TREATMENT_PROGRESSBAR_COMPONENT_LATENCY }}
						</label></div>
				</div>
			</ngb-progressbar>
			}
			@if (correction().days) {
			<ngb-progressbar [value]="correction().size" [max]="TOTAL_SIZE">
				<div class="text-center">
					<div><img id="correction_icon" src="images/ico_correction_white.png" alt="correction_icon"></div>
					<div><label for="correction_icon" class="overflow-hidden px-3">
							{{ labels().TREATMENT_PROGRESSBAR_COMPONENT_CORRECTION }}
						</label></div>
				</div>
			</ngb-progressbar>
			}
			@if (consolidation().days) {
			<ngb-progressbar [value]="consolidation().size" [max]="TOTAL_SIZE">
				<div class="text-center">
					<div><img id="consolidation_icon" src="images/ico_consolidation_white.png" alt="consolidation_icon"></div>
					<div><label for="consolidation_icon" class="overflow-hidden px-3">
							{{ labels().TREATMENT_PROGRESSBAR_COMPONENT_CONSOLIDATION }}
						</label></div>
				</div>
			</ngb-progressbar>
			}
			<ngb-progressbar [value]="REMOVAL_SIZE" [max]="TOTAL_SIZE">
				<div class="text-center">
					<div><img id="activity_removal_icon" src="images/ico_activity_removal_white.png" alt="activity_removal_icon">
					</div>
					<div><label for="activity_removal_icon" class="overflow-hidden px-3">
							{{ labels().TREATMENT_PROGRESSBAR_COMPONENT_APPROXIMATE_REMOVAL }}
						</label></div>
				</div>
			</ngb-progressbar>
		</ngb-progressbar-stacked>
		<ngb-progressbar-stacked>
			@if (latency().days) {
			<ngb-progressbar type="primary" [value]="latency().size" [max]="TOTAL_SIZE"
				data-testid="SUBSYS5_TREATPROGRESSBAR_LATENCYDAYS_TXT">
				{{ latency().days }} {{ labels().TREATMENT_PROGRESSBAR_COMPONENT_DAYS }}
			</ngb-progressbar>
			}
			@if (correction().days) {
			<ngb-progressbar type="warning" [value]="correction().size" [max]="TOTAL_SIZE"
				data-testid="SUBSYS5_TREATPROGRESSBAR_CORRECTIONDAYS_TXT">
				{{ correction().days }} {{ labels().TREATMENT_PROGRESSBAR_COMPONENT_DAYS }}
			</ngb-progressbar>
			}
			@if (consolidation().days) {
			<ngb-progressbar type="success" [value]="consolidation().size" [max]="TOTAL_SIZE"
				data-testid="SUBSYS5_TREATPROGRESSBAR_CONSOLIDATIONDAYS_TXT">
				{{ consolidation().days }} {{ labels().TREATMENT_PROGRESSBAR_COMPONENT_DAYS }}
			</ngb-progressbar>
			}
		</ngb-progressbar-stacked>
		<ngb-progressbar-stacked class="progress-bar-invisible treatment-date-bar">
			@if (latency().days) {
			<ngb-progressbar [value]="latency().size" [max]="TOTAL_SIZE" class="text-start">
				<span data-testid="SUBSYS5_TREATPROGRESSBAR_LATENCYDATE_TXT">{{ latency().date | convertDate }}</span>
			</ngb-progressbar>
			}
			@if (correction().days) {
			<ngb-progressbar [value]="correction().size" [max]="TOTAL_SIZE" class="text-start">
				<span data-testid="SUBSYS5_TREATPROGRESSBAR_CORRECTIONDATE_TXT">
					{{ correction().date | convertDate:false }}</span>
			</ngb-progressbar>
			}
			@if (consolidation().days) {
			<ngb-progressbar [value]="consolidation().size" [max]="TOTAL_SIZE" class="text-start">
				<span data-testid="SUBSYS5_TREATPROGRESSBAR_CONSOLIDATIONDATE_TXT">
					{{ consolidation().date | convertDate:false }}
				</span>
			</ngb-progressbar>
			}
			<ngb-progressbar [value]="REMOVAL_SIZE" [max]="TOTAL_SIZE" class="text-start">
				<span data-testid="SUBSYS5_TREATPROGRESSBAR_REMOVALDATE_TXT">
					{{ consolidationDate() | convertDate:false }}</span>
			</ngb-progressbar>
		</ngb-progressbar-stacked>
	</div>
</div>